// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".do-not-sell-link[data-v-1ed92a05]{color:#a3a5a6;cursor:pointer;text-decoration:underline}", ""]);
// Exports
module.exports = exports;
